export interface PlaceDetails {
  fetchFields: (request: {
    fields: string[];
    sessionToken?: google.maps.places.AutocompleteSessionToken;
  }) => Promise<unknown>;
  addressComponents?: Array<{
    longText?: string;
    shortText?: string;
    types: string[];
  }>;
  location?: {
    lat: number | (() => number);
    lng: number | (() => number);
  };
}

export interface PlacesLibrary {
  AutocompleteSessionToken: new () => google.maps.places.AutocompleteSessionToken;
  AutocompleteSuggestion: {
    fetchAutocompleteSuggestions: (request: {
      input: string;
      includedPrimaryTypes?: string[];
      includedRegionCodes?: string[];
      locationBias?: {
        center: { lat: number; lng: number };
        radius: number;
      };
      sessionToken?: google.maps.places.AutocompleteSessionToken;
    }) => Promise<{
      suggestions: Array<{
        placePrediction?: {
          placeId: string;
          text: { text: string };
          mainText?: { text: string };
          secondaryText?: { text: string };
        };
      }>;
    }>;
  };
  Place: new (options: { id: string }) => PlaceDetails;
}

let placesLibraryPromise: Promise<PlacesLibrary> | undefined;

const getPlacesLibrary = (): Promise<PlacesLibrary> => {
  if (!window.google?.maps) {
    return Promise.reject(new Error('Google map api is not available.'));
  }

  if (!placesLibraryPromise) {
    const importLibrary = window.google.maps.importLibrary;

    placesLibraryPromise = importLibrary
      ? (importLibrary('places') as Promise<PlacesLibrary>)
      : Promise.resolve(window.google.maps.places as unknown as PlacesLibrary);
  }

  return placesLibraryPromise;
};

export const resetPlacesLibrary = (): void => {
  placesLibraryPromise = undefined;
};

export default getPlacesLibrary;
